import React, { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { Quote } from "lucide-react";
import { testimonialsApi } from '../api/phpApi';
import "../styles/Testimonials.css";

export default function Testimonials() {
  const [data, setData] = useState({
    title: '',
    testimonials: []
  });
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [index, setIndex] = useState(0);

  useEffect(() => {
    fetchTestimonialsData();
  }, []);

  useEffect(() => {
    if (data.testimonials.length > 0) {
      const timer = setInterval(() => {
        setIndex((prev) => (prev + 1) % data.testimonials.length);
      }, 6000);
      return () => clearInterval(timer);
    }
  }, [data.testimonials.length]);

  const fetchTestimonialsData = async () => {
    try {
      setLoading(true);
      const testimonialsData = await testimonialsApi.get();

      if (testimonialsData) {
        setData({
          title: testimonialsData.section_title || '',
          testimonials: testimonialsData.testimonials || []
        });
      } else {
        // Fallback data if no data from API
        setData({
          title: 'Ce qu\'ils disent de nous',
          testimonials: [
            {
              name: "Ahmed Bennani",
              position: "Directeur Général",
              company: "Entreprise Marocaine",
              testimonial: "IAMAR a transformé notre approche de l'innovation. Leur expertise en gouvernance et développement durable nous a permis d'atteindre nos objectifs stratégiques.",
              rating: 5
            },
            {
              name: "Fatima Alaoui",
              position: "Responsable RH",
              company: "Groupe Financier",
              testimonial: "Les formations dispensées par IAMAR sont d'une qualité exceptionnelle. Nos équipes ont acquis des compétences essentielles pour l'avenir.",
              rating: 5
            },
            {
              name: "Mohammed Tazi",
              position: "CEO",
              company: "Tech Startup",
              testimonial: "La collaboration avec IAMAR nous a ouvert de nouvelles perspectives. Leur réseau international et leur expertise sectorielle sont incomparables.",
              rating: 5
            }
          ]
        });
      }
    } catch (error) {
      console.error('Error fetching testimonials data:', error);
      setError('Failed to load testimonials content');
      // Fallback data on error
      setData({
        title: 'Ce qu\'ils disent de nous',
        testimonials: [
          {
            name: "Ahmed Bennani",
            position: "Directeur Général",
            company: "Entreprise Marocaine",
            testimonial: "IAMAR a transformé notre approche de l'innovation. Leur expertise en gouvernance et développement durable nous a permis d'atteindre nos objectifs stratégiques.",
            rating: 5
          },
          {
            name: "Fatima Alaoui",
            position: "Responsable RH",
            company: "Groupe Financier",
            testimonial: "Les formations dispensées par IAMAR sont d'une qualité exceptionnelle. Nos équipes ont acquis des compétences essentielles pour l'avenir.",
            rating: 5
          },
          {
            name: "Mohammed Tazi",
            position: "CEO",
            company: "Tech Startup",
            testimonial: "La collaboration avec IAMAR nous a ouvert de nouvelles perspectives. Leur réseau international et leur expertise sectorielle sont incomparables.",
            rating: 5
          }
        ]
      });
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="max-w-3xl mx-auto my-16 px-6 text-center">Loading testimonials...</div>;
  }

  if (error) {
    return <div className="max-w-3xl mx-auto my-16 px-6 text-center">Error: {error}</div>;
  }

  if (!data.testimonials.length) {
    return <div className="max-w-3xl mx-auto my-16 px-6 text-center">No testimonials available</div>;
  }

  return (
    <section className="max-w-3xl mx-auto my-16 px-6 text-center relative">
      <h2 className="text-3xl font-bold mb-10 text-gray-900">
        {data.title}
      </h2>

      <div className="relative">
        <AnimatePresence mode="wait">
          <motion.div
            key={index}
            initial={{ opacity: 0, y: 30 }}
            animate={{ opacity: 1, y: 0 }}
            exit={{ opacity: 0, y: -30 }}
            transition={{ duration: 0.6 }}
            className="bg-white shadow-xl rounded-3xl p-10 mx-auto max-w-xl border border-gray-100 backdrop-blur-sm"
          >
            <Quote className="w-10 h-10 text-blue-600 mx-auto mb-4 opacity-80" />
            <p className="text-lg italic text-gray-700 mb-6">
              "{data.testimonials[index].text}"
            </p>
            <div className="font-semibold text-gray-900">{data.testimonials[index].name}</div>
            <div className="text-gray-500 text-sm">{data.testimonials[index].role}</div>
          </motion.div>
        </AnimatePresence>
      </div>



    </section>
  );
}
